import React, { useState, useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { GameProvider } from "./Menu/GameContext";
import UsersPage from "./Menu/UsersPage";
import UsersPageAstroad from "./Menu/UsersPageAstroad";
import UsersPageGenix from "./Menu/UsersPageGenix";
import UsersPageEchoesOfSelf from "./Menu/UsersPageEchoesOfSelf";
import UsersPageFrostville from "./Menu/UsersPageFrostville";
import UsersPageBlockhop from "./Menu/UsersPageBlockhop";
import HoroscopeListDetail from "./Menu/HoroscopeListDetail";
import Dashboard from "./components/Dashboard";
import LoginPage from "./components/LoginPage";
import Sidebar from "./components/Sidebar";
import { LanguageProvider } from "./context/LanguageContext";
import Settings from "./components/Settings";
import GamesPage from "./Menu/GamesPage";

export const gameDetails: { [key: string]: { name: string; logo: string } } = {
  game1: { name: "Trezzure", logo: require("./assets/Trezzure.png") },
  game2: { name: "Perkup", logo: require("./assets/PerkUp.png") },
  game3: { name: "Pawzle", logo: require("./assets/Pawzle.png") },
  game4: { name: "Astroad", logo: require("./assets/Astroad.png") },
  game5: { name: "Paradox", logo: require("./assets/Paradox.png") },
  game6: { name: "Genix", logo: require("./assets/Genix.png") },
  game7: { name: "Echoes of Self", logo: require("./assets/EchoesOfSelf.png") },
  game8: { name: "Frostville", logo: require("./assets/FrostVille.png") },
  game9: { name: "Blockhop", logo: require("./assets/BlockHop.png") },
};

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (authenticated: boolean) => {
    setIsAuthenticated(authenticated);
    if (authenticated) {
      localStorage.setItem('isAuthenticated', 'true');
    }
  };

  useEffect(() => {
    const auth = localStorage.getItem('isAuthenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
      <div className="flex h-screen">
        <Sidebar />
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    );
  };

  return (
    <LanguageProvider>
      <GameProvider>
        <Router>
          <Routes>
            <Route path="/" element={isAuthenticated ? <MainLayout><Dashboard /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="/settings" element={isAuthenticated ? <MainLayout><Settings /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/games" element={isAuthenticated ? <MainLayout><GamesPage /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/:gameKey" element={isAuthenticated ? <MainLayout><UsersPage /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game4" element={isAuthenticated ? <MainLayout><UsersPageAstroad /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game6" element={isAuthenticated ? <MainLayout><UsersPageGenix /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game7" element={isAuthenticated ? <MainLayout><UsersPageEchoesOfSelf /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game8" element={isAuthenticated ? <MainLayout><UsersPageFrostville /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game9" element={isAuthenticated ? <MainLayout><UsersPageBlockhop /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/horoscope-list/:userId" element={isAuthenticated ? <MainLayout><HoroscopeListDetail /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
            <Route path="/users/game4/:userId" element={isAuthenticated ? <MainLayout><HoroscopeListDetail /></MainLayout> : <LoginPage onLogin={handleLogin} />} />
          </Routes>
        </Router>
      </GameProvider>
    </LanguageProvider>
  );
};

export default App;